import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    description: {
      mandatee:
        'We are sorry, we cannot open your client’s bank account.\n\n' +
        'As a financial institution we are obliged to respect strict measures regarding Economic Sanctions.\n\n' +
        'We sincerely apologise for the inconvenience.',
      nonMandatee:
        'We are sorry, we cannot open your bank account.\n\n' +
        'As a financial institution we are obliged to respect strict measures regarding Economic Sanctions.\n\n' +
        'We sincerely apologise for the inconvenience.',
    },
    title: {
      mandatee: 'Sorry, we can’t open your client’s account',
      nonMandatee: 'Sorry, we can’t open your account',
    },
  },
  fr: {
    description: {
      mandatee:
        'Nous ne sommes pas en mesure de créer un compte pour votre client.\n\n' +
        'En tant qu’établissement financier, nous sommes tenus de respecter des règles strictes concernant les Sanctions Économiques appliquées à l’international.\n\n' +
        'Nous sommes sincèrement désolés de ne pas pouvoir l’accueillir.',
      nonMandatee:
        'Nous ne sommes pas en mesure de créer un compte pour votre entreprise.\n\n' +
        'En tant qu’établissement financier, nous sommes tenus de respecter des règles strictes concernant les Sanctions Économiques appliquées à l’international.\n\n' +
        'Nous sommes sincèrement désolés de ne pas pouvoir vous accueillir.',
    },
    title: {
      mandatee: 'Nous sommes désolés',
      nonMandatee: 'Nous sommes désolés',
    },
  },
} as const);
